__turbopack_context__.v({
  "blok-big-title": "SizePicker-module__tGLuna__blok-big-title",
  "blok-subtitle": "SizePicker-module__tGLuna__blok-subtitle",
  "blok-title": "SizePicker-module__tGLuna__blok-title",
  "selected": "SizePicker-module__tGLuna__selected",
  "size": "SizePicker-module__tGLuna__size",
  "sizes": "SizePicker-module__tGLuna__sizes",
});
